import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SlackBrandLogo from "../assets/SlackBrandLogo.svg";
import TeamsBrandLogo from "../assets/TeamsBrandLogo.svg";
import DiscordBrandLogo from "../assets/DiscordBrandLogo.svg";
import MobileBrandLogo from "../assets/HorizontalPageParrot.svg";
import { useAuth } from "../contexts/AuthContext";
import { useTranslation } from '../hooks/useTranslation';

export default function RegisterWorkspace({ 
    clientData, 
    clientDataLoading,
    setIsWorkspaceRegisterOpen 
}) {

// see deprecated SlacckLayout for the search params that are caught then redirected here, taking over register workspace for all options
 /**  const location = useLocation();
  const navigate = useNavigate();
  const safety = useRef(false);
  const { url } = useAuth();

  const { code, posting, error, call } = useAuthPostFetch();

  console.log("Render RegisterWorkspace");
  //?workspace=T062RGKE5EH&workspaceToken=-1738825976
  useEffect(() => {
    console.log("RegisterWorkspace: useEffect");
    console.log(code, error, posting);
    if (code) {
      console.log("navigate to ..");
      navigate("..", { state: { code }, replace: true });
    }
    if (error) {
      navigate("..", { state: { error }, replace: true });
    }
    if (posting) return;
    if (safety.current){
      console.log("safety");
      return;
    }
    const furl = `${url}/webapp/register-workspace`;
    const data = {
      workspace: location.state?.workspace,
      workspaceToken: location.state?.workspaceToken,
    };
    if(data.workspace && data.workspaceToken) {
      safety.current = true;
      call(furl, data).then(() => { console.log("call done"); });
    }
  });*/
    const navigate = useNavigate();
    const t = useTranslation();

    function isFreeSubscription() {
        if (clientData && clientData.subscriptions && clientData.subscriptions.length > 0) {
            for (const subscription of clientData.subscriptions) {
                if (!subscription.workspace) {
                    return true;
                }
            }
        }
        return false;
    }

    async function handleSlackRegister() {
        if (isFreeSubscription()) {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/register-slack");
        } else {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/subscribe", { state: { workspace: "slack" } });
        }
    }

    async function handleTeamsRegister() {
        if (isFreeSubscription()) {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/register-teams");
        } else {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/subscribe", { state: { workspace: "teams" } });
        }
    }

    async function handleDiscordRegister() {
        if (isFreeSubscription()) {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/register-discord");
        } else {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/subscribe", { state: { workspace: "discord" } });
        }
    }

    async function handleMobileRegister() {
        if (isFreeSubscription()) {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/register-mobile");
        } else {
            setIsWorkspaceRegisterOpen(false);
            return navigate("../auth/subscribe", { state: { workspace: "mobile" } });
        }
    }

    return (
        <div className="register-workspace-container">
            <div className="register-workspace-title">{t('Create Your Workspace')}</div>
            <div className="register-workspace-list">
                <RegisterWorkspaceOption logo={SlackBrandLogo} name="Slack" onClick={handleSlackRegister} />
                <RegisterWorkspaceOption logo={TeamsBrandLogo} name="Teams" onClick={handleTeamsRegister} />
                <RegisterWorkspaceOption logo={DiscordBrandLogo} name="Discord" onClick={handleDiscordRegister} />
                <RegisterWorkspaceOption logo={MobileBrandLogo} name="Mobile" onClick={handleMobileRegister} />
            </div>
        </div>
    );
}

function RegisterWorkspaceOption({ logo, name, onClick }) {
    const t = useTranslation();
    
    return (
        <div onClick={onClick} className="register-workspace-option">
            <img className="register-workspace-option-logo" src={logo} alt={name}/>
            <span className="register-workspace-option-name mv-auto">{t('Connect')}{/*name*/}</span>
        </div>
    );
}
